"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { ThemeProvider } from "next-themes";
import { Suspense, useEffect, useState } from "react";
import { InteractionScale } from "@/components/interaction-scale";
import { NoticeProvider } from "@/components/notice";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useAppearance } from "@/lib/browser/use-appearance";
import {
  initializeCloudWatchRum,
  setCloudWatchRumPage,
} from "@/lib/client/cloudwatch-rum";
import { getClientQueryClient } from "@/lib/client/query-client";

function CloudWatchRumProvider() {
  const pathname = usePathname();

  useEffect(() => {
    setCloudWatchRumPage(pathname);
  }, [pathname]);

  useEffect(() => {
    void initializeCloudWatchRum();
  }, []);

  return null;
}

// ほかのタブで変えたアクセントカラーと背景を、このタブにも反映する。
function AppearanceSync() {
  useAppearance();
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => getClientQueryClient());
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Suspense fallback={null}>
            <CloudWatchRumProvider />
          </Suspense>
          <NoticeProvider>{children}</NoticeProvider>
          <InteractionScale />
          <AppearanceSync />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
